/* istanbul ignore file */

import { AuthRoleCodeEnum, Company, User } from '@generated/types.d'

import { RecursivePartial } from 'index'

export const hasAdminAccess = (
  company: RecursivePartial<Company>,
  user: RecursivePartial<User>,
): boolean =>
  user?.roles.some(
    (role) =>
      role?.code === AuthRoleCodeEnum.Administrator &&
      role?.companyId === company?.id,
  )

export const isCurrentUserAdmin = (currentUser: any): boolean => {
  const userIsAdmin = currentUser?.roles?.find(
    (role) => role?.code === 'ADMINISTRATOR',
  )

  return !!userIsAdmin || currentUser?.hasAdminRole
}
